import { Paths } from "@app/routes";
import { Tabs, TabsList, TabsTrigger } from "@atlas/core";
import { useTranslation } from "@atlas/sdk";
import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router";
import { DeploymentsTab } from "./DeploymentsTab";
import { PackagesTab } from "./PackagesTab";

export function PackageManagerPage() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const viewParam = searchParams.get("view");
  const activeTab =
    tabParam === "deployments"
      ? "deployments"
      : tabParam === Paths.PackageManagerViewPackages ||
          viewParam === Paths.PackageManagerViewPackages
        ? "packages"
        : "packages";

  useEffect(() => {
    const params = new URLSearchParams(search);
    if (params.get("view") !== Paths.PackageManagerViewPackages) return;
    const tParam = params.get("tab");
    if (
      tParam === Paths.PackageManagerViewPackages ||
      tParam === "deployments"
    ) {
      return;
    }
    params.delete("view");
    params.set("tab", Paths.PackageManagerViewPackages);
    setSearchParams(params, { replace: true });
  }, [search, setSearchParams]);

  const onTabChange = (value: string) => {
    const next = new URLSearchParams(searchParams);
    next.delete("view");
    next.set("tab", value);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <Tabs
        value={activeTab}
        onValueChange={onTabChange}
        className="flex-1 flex flex-col min-h-0">
        <TabsList variant="line" size="md">
          <TabsTrigger value="packages">
            {t("hub.package_manager.tab_packages")}
          </TabsTrigger>
          <TabsTrigger value="deployments">
            {t("hub.package_manager.tab_deployments")}
          </TabsTrigger>
        </TabsList>

        <PackagesTab />
        <DeploymentsTab />
      </Tabs>
    </div>
  );
}
